/** Normalize user-entered social / web URLs for storage and safe href use. */
export function normalizeSocialUrl(raw) {
  const s = (raw || '').trim();
  if (!s) return '';
  if (/^javascript:/i.test(s) || /^data:/i.test(s)) return '';
  const withProtocol = /^https?:\/\//i.test(s)
    ? s
    : `https://${s.replace(/^\/+/, '')}`;
  try {
    const u = new URL(withProtocol);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
    return u.href;
  } catch {
    return '';
  }
}

export function socialHref(stored) {
  const h = normalizeSocialUrl(stored);
  return h || null;
}
